import { useTranslations } from "@fenetech/translations";
import { Accordion, AccordionDetails, Grid, Typography } from "@mui/material";
import AccordionSummarySlim from "components/Common/AccordionSummarySlim";
import SelectForm from "components/Common/SelectForm";
import Constants from "helpers/constants";
import React from 'react';
import CompanyRequiredFields from "./CompanyRequiredFields";
import useQuoteClassifications from "helpers/context/SelectionValues/useQuoteClassifications";

interface IProps {
    readOnly: boolean,
    termsExist: boolean
}

const CompanyQuoteSettings: React.FC<IProps> = ({ readOnly, termsExist }: IProps) => {

    const tm = useTranslations();
    const appClassifications = useQuoteClassifications();

    const [isExpanded, setIsEpanded] = React.useState<boolean>(true);

    return <>
        <Accordion expanded={isExpanded} onChange={() => setIsEpanded((prev) => !prev)} disableGutters >
            <AccordionSummarySlim>
                <Typography>
                    {tm.Get("Quote Settings")}
                </Typography>
            </AccordionSummarySlim>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <SelectForm
                            fieldName="defaultClassification"
                            dataSource={appClassifications?.GetQuoteClassificationsBeforeUpload()}
                            translateDisplayField={(description: string) => Constants.Strings.Classifications.includes(description)}
                            keyField="classificationID"
                            valueField="classificationID"
                            displayField="description"
                            label={tm.Get("Default Quote Status")}
                            readOnly={readOnly}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CompanyRequiredFields 
                            readOnly={readOnly}
                            termsExist={termsExist}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    </>;
}

export default CompanyQuoteSettings;